import {styled} from 'styled-components';

const CenteredColumnContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: stretch;
    align-items: center;
    height: inherit;
`;

export {CenteredColumnContainer};
